// extracted by mini-css-extract-plugin
export var ctnText = "scattered-hero-module--ctnText--h4UKK";
export var heroTextContent = "scattered-hero-module--heroTextContent--phN5+";
export var outerCtn = "scattered-hero-module--outerCtn--IP8NE";
export var scatteredCtn = "scattered-hero-module--scatteredCtn--KvWvn";
export var scatteredHero = "scattered-hero-module--scatteredHero--gio70";
export var scatteredImg = "scattered-hero-module--scatteredImg--lVnQ7";
export var scatteredImgs = "scattered-hero-module--scatteredImgs--RI5Bx";
export var shortDescription = "scattered-hero-module--shortDescription--8I9XX";